var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('v-row',{staticClass:"fill-height",attrs:{"justify":"start","align":"center"}},[_vm._l((_vm.Productos),function(item){return [_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('Producto_item',{attrs:{"item":item}})],1)]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }